export default __webpack_public_path__ + "static/media/bg.7c448ff9.jpg";